import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, tap, of, Subscription, startWith } from 'rxjs';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor } from '@angular/common';

import { LoadingSpinnerComponent } from '../../utils/loading-spinner.component';
import { AdditionalInput } from '../../../models/datacenter-aggrid-view';
import { ProductListFilterApiService } from '../services/product-list-filter-api.service';

@Component({
	selector: 'copo-product-suggestive-item-filter',
	templateUrl: './suggestive-item-filter.component.html',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,

		MatFormFieldModule,

		MatInputModule,

		MatAutocompleteModule,
		FormsModule,
		ReactiveFormsModule,
		MatIconModule,

		MatOptionModule,
		LoadingSpinnerComponent,
		NgFor,
	],
})
export class ProductSuggestiveItemFilterComponent implements OnInit, OnDestroy {
	@Input() placeholder?: string;
	@Input() filterValue?: { code?: string | undefined; translation?: string | undefined };
	@Input() additionalInput?: AdditionalInput;
	suggestiveCtrl = new FormControl();

	filteredItems?: { code?: string | undefined; translation?: string }[];
	isLoading = false;

	private readonly textSub: Subscription;

	constructor(
		private readonly filterApiService: ProductListFilterApiService
	) {
		this.textSub = this.suggestiveCtrl.valueChanges
			.pipe(
				startWith(this.suggestiveCtrl.value),
				debounceTime(300),
				distinctUntilChanged(),
				tap((searchText: string) => {
					if (this.filterValue) {
						this.filterValue.translation = searchText;
					}
					this.filteredItems = [];
					this.isLoading = true;
				}),
				switchMap((query: string) => {
					if (!this.additionalInput) {
						return of([]);
					}
					return this.filterApiService
						.getItemBySearchTextAndAdditionalInput(this.additionalInput, query);
				}),
			).subscribe({
				next: value => {
					this.filteredItems = value;
					this.isLoading = false;
				},
				error: (error: unknown) => {
					this.isLoading = false;
					console.error(error);
				}
			});
	}

	ngOnInit() {
		if (!this.filterValue?.translation) {
			return;
		}
		this.suggestiveCtrl.setValue(this.filterValue.translation);
	}

	propositionChanged(proposition: { code?: string; translation?: string }) {
		if (!this.filterValue) {
			return;
		}
		Object.assign(this.filterValue, proposition);
	}

	ngOnDestroy() {
		this.textSub.unsubscribe();
	}
}
